module.exports = __webpack_public_path__ + "images/147_160.jpg";